export default {
      id: "oc-res-vminstance-container-usage",
      viewBox: "0 0 1027 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-vminstance-container",
      toString: function () {
        return this.url;
      }
    }